export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6267.b918d73d.jpg";